import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "timer-header" }
const _hoisted_3 = { class: "slider-container" }

import { useRouter } from 'vue-router'
import { useTimer } from '../composables/useTimer'
import ValueSlider from '@/components/ValueSlider.vue'
import { onMounted } from 'vue'
import { useBackground, BackgroundThemes } from '../composables/useBackground'


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const { exercises, work, rest, totalTime, time2Str } = useTimer()
const router = useRouter()
const { backgroundTheme } = useBackground()

function startWorkout () {
  router.push({ name: 'timer' })
}

onMounted(() => {
  backgroundTheme.value = BackgroundThemes.START
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h4", null, "Workout Time:", -1)),
      _createElementVNode("h2", null, _toDisplayString(_unref(time2Str)(_unref(totalTime))), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(ValueSlider, {
        min: 1,
        max: 20,
        modelValue: _unref(exercises),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(exercises) ? (exercises).value = $event : null))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Exercises: " + _toDisplayString(_unref(exercises)), 1)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(ValueSlider, {
        min: 5,
        max: 200,
        step: 5,
        modelValue: _unref(work),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(work) ? (work).value = $event : null))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Work: " + _toDisplayString(_unref(time2Str)(_unref(work))), 1)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(ValueSlider, {
        min: 5,
        max: 200,
        step: 5,
        modelValue: _unref(rest),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(rest) ? (rest).value = $event : null))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Rest: " + _toDisplayString(_unref(time2Str)(_unref(rest))), 1)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", { class: "button-container" }, [
      _createElementVNode("button", { onClick: startWorkout }, "Start Workout")
    ])
  ]))
}
}

})